import { html } from "lit";
import { getDummyText } from "../../../../utils";

interface ProductFootnotesTemplateArgs {
    footnotes?: string[];
}

const exampleFootnotes = [
    getDummyText(100),
    getDummyText(300),
    getDummyText(200),
];

export const ProductFootnotesTemplate = ({
    footnotes,
}: ProductFootnotesTemplateArgs) => html`
    <div class="ux-t-container">
        <p class="ux-text-tiny">
            Je nach Land sind Abweichungen von diesem Produktsortiment und von
            diesen Angaben möglich. Änderungen in Technik, Ausstattung, Preis
            und Zubehörangebot sind vorbehalten. Bitte setzen Sie sich mit Ihrem
            Ansprechpartner vor Ort in Verbindung, um zu erfahren, ob das
            Produkt in Ihrem Land verfügbar ist.
        </p>
        <div class="ux-iws-product-footnotes">
            <ux-collapsible
                direction="bottom"
                button-text-collapsed="Fußnoten"
                button-text-expanded="Fußnoten"
            >
                <ul>
                    ${(footnotes || exampleFootnotes).map(
                        (item) => html` <li>${item}</li> `
                    )}
                </ul>
            </ux-collapsible>
        </div>
    </div>
`;
